import porject1 from '../../assets/project1.png';
import porject2 from '../../assets/porject2.png';
import porject3 from '../../assets/project3.png';

const dataProj = [
 {id:1, title:'Nantucket Grill MOC',img:porject1,desc:'I currently work for a Restaurant to help pay my bills. So I decided to rebuild there website, they ended up no being interested in it.', link:'https://github.com/DominicD213/NanMoc'},
 {id:2, title:'Ai MOC',img:porject2, desc:'This was a practice mockup to help me get more formiliar with react.', link:'https://github.com/DominicD213/Chat-Gpt'},
 {id:3, title:'Typing Speed test',img:porject3, desc:'This project is currently still in the works. When it is finished it will be a fully functioning website that you can log into and track your scores. ', link:'https://github.com/DominicD213/TypeTest'}
]

export default dataProj;